
export default {
  directives: {
    DynamicEvents: {
      bind: function (el, binding, vnode) {
        const allEvents = binding.value;
        allEvents.forEach((event) => {
          // register handler in the dynamic component
          if (vnode.componentInstance) {
            vnode.componentInstance.$on(event, (eventData) => {
              // when the event is fired, the proxyEvent function is going to be called
              vnode.context.proxyEvent(event, eventData);
            });
          }
        });
      },
      unbind: function (el, binding, vnode) {
        if (vnode.componentInstance) {
          vnode.componentInstance.$off();
        }
      }
    }
  },
  methods: {
    updateFields: function (index) {
      this.$emit("save-state");
    },
    setFinished: function () {
      this.$emit("page-finished");
    },
    setNotFinished: function () {
      this.$emit("page-not-finished");
    },
    next: function () {
      this.$emit("next-page");
    },
    previous: function () {
      this.$emit("previous-page");
    },
    saveState: function () {
      this.$emit("save-state");
    },
    error: function(message) {
      this.$emit("error", message);
    },
    proxyEvent(eventName, eventData) {
      switch (eventName) {
        case "next-page":
          this.next()
          break;
        case "previous-page":
          this.previous()
          break;
        case "update-fields":
          this.updateFields()
          break;
        case "save-state":
          this.saveState()
          break;
        case "error":
          this.error(eventData)
          break;
        case "page-not-finished":
          console.log("fisk")
          this.setNotFinished()
          break;
        default:
          break;
      }
    }
  }
}